/** Downloads rows as a CSV file (Blob based, quotes and newlines escaped). Shared by the finance dashboard. */
export function downloadCsv(filename: string, headers: string[], rows: (string | number | null | undefined)[][]): void {
    const escape = (value: string | number | null | undefined): string => {
        const text = value === null || value === undefined ? '' : String(value);
        return /[",\n\r]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
    };
    const csv = [headers, ...rows].map(row => row.map(escape).join(',')).join('\r\n');
    const blob = new Blob(['﻿' + csv], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
